import { z } from "zod";

import { DateIsoString } from "@/core/types";
import { Attachment } from "@/data/attachments";
import { PayCode } from "@/data/pay-codes";

export const TimeReportProjectItem = z
  .object({
    id: z.number().nullable(),

    date: DateIsoString,
    reportedTime: z.number().nullable(),
    payCode: PayCode,

    comment: z.string().nullable(),
    attachments: z.array(Attachment).nullable(),
  })
  .passthrough();

export type TimeReportProjectItem = z.infer<typeof TimeReportProjectItem>;
